
export enum DrawingMode {
    SHAPE = "SHAPE",
    PROTECTION_ZONE = "PROTECTION_ZONE",
    POINTS = "POINTS",
    NONE = "NONE",
}
